/**
 * Application Configuration
 *
 * Central configuration for paths and settings used across the app.
 */
import type { Sport } from 'types/app';

const AppConfig = {
  // Path to training plan JSON files (relative to public directory)
  plansPath: '/plans/json/',

  // Get sport-specific plan path
  getSportPlansPath: (sport: Sport): string => {
    return `/plans/json/${sport}/`;
  },
};

export const Config = AppConfig;
